// src/mocks/data/verticals/medical_clinic.js
// Demo dataset for business_type="medical_clinic" (cabinet/clinică medicală).
// Use case profile: cabinet de osteopatie / kinetoterapie / recuperare.

export const BUSINESS = {
  id: 1,
  name: "Clinica MediCare",
  slug: "demo",
  business_type: "medical_clinic",
  email: "contact@clinica-medicare.ro",
  phone: "+40745123456",
  address: "Str. Decebal 18, Sector 3, București",
  country: "RO",
  currency: "RON",
  plan_code: "manager_pro",
  billing_cycle: "monthly",
  subscription_status: "active",
  current_period_end: "2026-12-31",
  grace_until: null,
  trial_used_at: "2026-01-01T10:00:00Z",
  trial_ends_at: null,
  stripe_customer_id: null,
  stripe_subscription_id: null,
  features: {
    appointments: true,
    clients: true,
    staff: true,
    services: true,
    stats: true,
    inventory: true,
    sms: false,
    sms_campaigns: false,
    chat: false,
  },
};

export const LOCATION = {
  id: 1,
  business: 1,
  name: "Clinica MediCare – Decebal",
  address: "Str. Decebal 18, Sector 3, București",
  phone: "+40745123456",
  email: "contact@clinica-medicare.ro",
  timezone: "Europe/Bucharest",
  is_active: true,
};

export const WORKING_HOURS = {
  location_id: 1,
  timezone: "Europe/Bucharest",
  recurring: {
    "0": [{ start: "08:00", end: "18:00" }],
    "1": [{ start: "08:00", end: "18:00" }],
    "2": [{ start: "08:00", end: "18:00" }],
    "3": [{ start: "08:00", end: "18:00" }],
    "4": [{ start: "08:00", end: "18:00" }],
    "5": [{ start: "09:00", end: "13:00" }],
    "6": [],
  },
};

export const BUSINESS_SETTINGS = {
  id: 1,
  name: "Clinica MediCare",
  slug: "demo",
  email: "contact@clinica-medicare.ro",
  phone: "+40745123456",
  address: "Str. Decebal 18, Sector 3, București",
  country: "RO",
  currency: "RON",
  timezone: "Europe/Bucharest",
  booking_buffer_minutes: 15,
  cancellation_policy: "Anularea programărilor se acceptă cu minimum 24h înainte. Întârzierile peste 15 minute pot duce la reprogramare.",
  logo: null,
};

export const CATEGORIES = [
  { id: 1, name: "Consultații",   business: 1, sort_order: 1 },
  { id: 2, name: "Tratamente",    business: 1, sort_order: 2 },
  { id: 3, name: "Investigații",  business: 1, sort_order: 3 },
];

export const SERVICES = [
  { id: 1, name: "Consultație inițială",      duration: 60,  price: "200.00", currency: "RON", category: "Consultații", business: 1, is_active: true, color: "#1F6FEB", description: "Evaluare completă: anamneză, examen clinic, plan terapeutic." },
  { id: 2, name: "Consultație de control",    duration: 30,  price: "100.00", currency: "RON", category: "Consultații", business: 1, is_active: true, color: "#3498DB", description: "Reevaluare la pacienții aflați în tratament." },
  { id: 3, name: "Osteopatie viscerală",      duration: 60,  price: "250.00", currency: "RON", category: "Tratamente", business: 1, is_active: true, color: "#16A085", description: "Tehnici manuale pentru organele abdomino-pelvine." },
  { id: 4, name: "Manipulare miofascială",    duration: 45,  price: "200.00", currency: "RON", category: "Tratamente", business: 1, is_active: true, color: "#27AE60", description: "Eliberare fascială pentru reducerea tensiunilor musculare." },
  { id: 5, name: "Tratament cervicalgie",     duration: 45,  price: "180.00", currency: "RON", category: "Tratamente", business: 1, is_active: true, color: "#2980B9", description: "Protocol pentru dureri cervicale și migrene de cauză cervicală." },
  { id: 6, name: "Tratament lombalgie",       duration: 60,  price: "220.00", currency: "RON", category: "Tratamente", business: 1, is_active: true, color: "#8E44AD", description: "Protocol pentru dureri lombare acute și cronice." },
  { id: 7, name: "Kinetoterapie",             duration: 45,  price: "150.00", currency: "RON", category: "Tratamente", business: 1, is_active: true, color: "#D35400", description: "Recuperare prin exerciții ghidate." },
  { id: 8, name: "Evaluare posturală",        duration: 45,  price: "180.00", currency: "RON", category: "Investigații", business: 1, is_active: true, color: "#7F8C8D", description: "Analiză posturală statică și dinamică, raport scris." },
];

export const STAFF = [
  {
    id: 1,
    first_name: "Dr. Andrei",
    last_name: "Popescu",
    email: "andrei.popescu@clinica-medicare.ro",
    phone: "+40745200001",
    role: "owner",
    color: "#1F6FEB",
    business: 1,
    location: 1,
    services: [1, 2, 3, 5, 6],
    is_active: true,
    avatar: "https://i.pravatar.cc/150?img=51",
    bio: "Medic osteopat cu 14 ani experiență, specializat în recuperare post-traumatică și dureri cronice de coloană.",
  },
  {
    id: 2,
    first_name: "Dr. Maria",
    last_name: "Ionescu",
    email: "maria.ionescu@clinica-medicare.ro",
    phone: "+40745200002",
    role: "employee",
    color: "#16A085",
    business: 1,
    location: 1,
    services: [1, 2, 7, 8],
    is_active: true,
    avatar: "https://i.pravatar.cc/150?img=44",
    bio: "Kinetoterapeut, specializare în recuperare neuromotorie și pregătire posturală.",
  },
  {
    id: 3,
    first_name: "Dr. Radu",
    last_name: "Constantinescu",
    email: "radu.constantinescu@clinica-medicare.ro",
    phone: "+40745200003",
    role: "employee",
    color: "#27AE60",
    business: 1,
    location: 1,
    services: [1, 3, 4, 5, 6],
    is_active: true,
    avatar: "https://i.pravatar.cc/150?img=33",
    bio: "Osteopat, formare D.O. internațională. Atestat în osteopatie viscerală.",
  },
  {
    id: 4,
    first_name: "Dr. Elena",
    last_name: "Dumitrescu",
    email: "elena.dumitrescu@clinica-medicare.ro",
    phone: "+40745200004",
    role: "employee",
    color: "#8E44AD",
    business: 1,
    location: 1,
    services: [2, 4, 7, 8],
    is_active: true,
    avatar: "https://i.pravatar.cc/150?img=47",
    bio: "Fizioterapeut, expertă în terapie miofascială și kinetoterapie sportivă.",
  },
];

export const TIME_OFF = [
  {
    id: 1,
    staff: 4,
    staff_name: "Dr. Elena Dumitrescu",
    start_date: (() => { const d = new Date(); d.setDate(d.getDate() + 14); return d.toISOString().split("T")[0]; })(),
    end_date: (() => { const d = new Date(); d.setDate(d.getDate() + 18); return d.toISOString().split("T")[0]; })(),
    type: "vacation",
    notes: "Concediu anual",
    approved: true,
  },
];

export const CLIENTS = [
  { id: 1,  first_name: "Andrei",     last_name: "Stoica",      phone: "+40745100001", email: "andrei.stoica@email.ro",     notes: "Discopatie L4-L5, recomandare neurolog", created_at: "2026-01-05T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=11" },
  { id: 2,  first_name: "Elena",      last_name: "Popescu",     phone: "+40745100002", email: "elena.popescu@email.ro",     notes: "Migrene cronice — 2-3 episoade/lună",     created_at: "2026-01-08T11:00:00Z", avatar: "https://i.pravatar.cc/150?img=2"  },
  { id: 3,  first_name: "Cristian",   last_name: "Marinescu",   phone: "+40745100003", email: "cristian.m@email.ro",        notes: "Sportiv amator — pregătire competiții",   created_at: "2026-01-10T09:30:00Z", avatar: "https://i.pravatar.cc/150?img=12" },
  { id: 4,  first_name: "Ioana",      last_name: "Dumitrescu",  phone: "+40745100004", email: "ioana.d@email.ro",           notes: "Postură proastă — lucrător birou",        created_at: "2026-01-12T14:00:00Z", avatar: "https://i.pravatar.cc/150?img=4"  },
  { id: 5,  first_name: "Bogdan",     last_name: "Gheorghe",    phone: "+40745100005", email: "bogdan.g@email.ro",          notes: "Pacient VIP — recomandare colaborator",   created_at: "2026-01-15T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=15" },
  { id: 6,  first_name: "Cristina",   last_name: "Stoica",      phone: "+40745100006", email: "",                           notes: "Hipertensivă — atenție la presiune",      created_at: "2026-01-20T11:00:00Z", avatar: "https://i.pravatar.cc/150?img=8"  },
  { id: 7,  first_name: "Mihai",      last_name: "Marin",       phone: "+40745100007", email: "mihai.marin@email.ro",       notes: "Operație disc lombar 2024 — recuperare",  created_at: "2026-01-22T09:00:00Z", avatar: "https://i.pravatar.cc/150?img=33" },
  { id: 8,  first_name: "Alina",      last_name: "Popa",        phone: "+40745100008", email: "alina.popa@email.ro",        notes: "Preferă programări dimineața",            created_at: "2026-01-25T10:30:00Z", avatar: "https://i.pravatar.cc/150?img=10" },
  { id: 9,  first_name: "Vlad",       last_name: "Radu",        phone: "+40745100009", email: "",                           notes: "Cervicalgie cronică",                     created_at: "2026-01-28T13:00:00Z", avatar: "https://i.pravatar.cc/150?img=53" },
  { id: 10, first_name: "Mihaela",    last_name: "Lungu",       phone: "+40745100010", email: "mihaela.l@email.ro",         notes: "Recuperare post-fractură umăr",           created_at: "2026-02-01T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=13" },
  { id: 11, first_name: "Tudor",      last_name: "Nistor",      phone: "+40745100011", email: "tudor.n@email.ro",           notes: "Lombalgie acută — recomandat de medic familie", created_at: "2026-02-03T11:00:00Z", avatar: "https://i.pravatar.cc/150?img=68" },
  { id: 12, first_name: "Roxana",     last_name: "Stan",        phone: "+40745100012", email: "",                           notes: "",                                        created_at: "2026-02-05T14:00:00Z", avatar: "https://i.pravatar.cc/150?img=15" },
  { id: 13, first_name: "Sebastian",  last_name: "Bucur",       phone: "+40745100013", email: "sebastian.b@email.ro",       notes: "Sciatică dreaptă recidivantă",            created_at: "2026-02-08T09:00:00Z", avatar: "https://i.pravatar.cc/150?img=60" },
  { id: 14, first_name: "Simona",     last_name: "Tudor",       phone: "+40745100014", email: "simona.t@email.ro",          notes: "Tensiune cervicală — sarcină 28 săpt.",   created_at: "2026-02-10T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=17" },
  { id: 15, first_name: "George",     last_name: "Neagu",       phone: "+40745100015", email: "",                           notes: "Scolioză — monitorizare lunară",          created_at: "2026-02-12T11:30:00Z", avatar: "https://i.pravatar.cc/150?img=58" },
  { id: 16, first_name: "Dan",        last_name: "Ciobanu",     phone: "+40745100016", email: "dan.c@email.ro",             notes: "",                                        created_at: "2026-02-15T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=64" },
  { id: 17, first_name: "Luminița",   last_name: "Vlad",        phone: "+40745100017", email: "",                           notes: "Nu trimite SMS — preferă apel",           created_at: "2026-02-18T14:00:00Z", avatar: "https://i.pravatar.cc/150?img=21" },
  { id: 18, first_name: "Victor",     last_name: "Dinu",        phone: "+40745100018", email: "victor.d@email.ro",          notes: "Sportiv profesionist — recuperare ATM",   created_at: "2026-02-20T09:00:00Z", avatar: "https://i.pravatar.cc/150?img=66" },
  { id: 19, first_name: "Nicoleta",   last_name: "Grigore",     phone: "+40745100019", email: "",                           notes: "Tensiune cervicală cronică",              created_at: "2026-02-22T11:00:00Z", avatar: "https://i.pravatar.cc/150?img=23" },
  { id: 20, first_name: "Alexandru",  last_name: "Anghel",      phone: "+40745100020", email: "alex.anghel@email.ro",       notes: "Pacient nou — recomandat colaborator",    created_at: "2026-02-25T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=70" },
];

let _id = 1;
function appt({ clientId, clientName, clientPhone, staffId, serviceId, serviceName, servicePrice, daysOffset, hour, minute = 0, duration, status, notes = "" }) {
  const start = new Date();
  start.setDate(start.getDate() + daysOffset);
  start.setHours(hour, minute, 0, 0);
  const end = new Date(start.getTime() + duration * 60 * 1000);
  const startIso = start.toISOString();
  const endIso = end.toISOString();
  return {
    id: _id++,
    client_id: clientId,
    client_name: clientName,
    client_phone: clientPhone,
    service_id: serviceId,
    service_name: serviceName,
    service_ids: [serviceId],
    service_names: [serviceName],
    service_price: servicePrice,
    employee: staffId,
    staff_id: staffId,
    staff_name: "",
    location: 1,
    start_time: startIso,
    end_time: endIso,
    start_at: startIso,
    end_at: endIso,
    status,
    notes,
  };
}

export const APPOINTMENTS = [
  appt({ clientId: 5,  clientName: "Bogdan Gheorghe",     clientPhone: "+40745100005", staffId: 1, serviceId: 6, serviceName: "Tratament lombalgie",    servicePrice: 220, daysOffset: -13, hour: 10,  duration: 60,  status: "completed" }),
  appt({ clientId: 10, clientName: "Mihaela Lungu",       clientPhone: "+40745100010", staffId: 4, serviceId: 7, serviceName: "Kinetoterapie",          servicePrice: 150, daysOffset: -12, hour: 9,   duration: 45,  status: "completed", notes: "Ședința 4/10 — recuperare umăr" }),
  appt({ clientId: 2,  clientName: "Elena Popescu",       clientPhone: "+40745100002", staffId: 3, serviceId: 5, serviceName: "Tratament cervicalgie",  servicePrice: 180, daysOffset: -11, hour: 11,  duration: 45,  status: "completed" }),
  appt({ clientId: 14, clientName: "Simona Tudor",        clientPhone: "+40745100014", staffId: 2, serviceId: 7, serviceName: "Kinetoterapie",          servicePrice: 150, daysOffset: -10, hour: 14,  duration: 45,  status: "completed", notes: "Adaptare exerciții — sarcină" }),
  appt({ clientId: 7,  clientName: "Mihai Marin",         clientPhone: "+40745100007", staffId: 1, serviceId: 4, serviceName: "Manipulare miofascială", servicePrice: 200, daysOffset: -9,  hour: 10,  duration: 45,  status: "completed" }),
  appt({ clientId: 16, clientName: "Dan Ciobanu",         clientPhone: "+40745100016", staffId: 3, serviceId: 1, serviceName: "Consultație inițială",   servicePrice: 200, daysOffset: -8,  hour: 9,   duration: 60,  status: "cancelled", notes: "Pacient a anulat cu 2h înainte" }),
  appt({ clientId: 8,  clientName: "Alina Popa",          clientPhone: "+40745100008", staffId: 4, serviceId: 8, serviceName: "Evaluare posturală",     servicePrice: 180, daysOffset: -7,  hour: 11,  duration: 45,  status: "completed" }),
  appt({ clientId: 11, clientName: "Tudor Nistor",        clientPhone: "+40745100011", staffId: 1, serviceId: 6, serviceName: "Tratament lombalgie",    servicePrice: 220, daysOffset: -6,  hour: 9,   duration: 60,  status: "completed" }),
  appt({ clientId: 3,  clientName: "Cristian Marinescu",  clientPhone: "+40745100003", staffId: 2, serviceId: 7, serviceName: "Kinetoterapie",          servicePrice: 150, daysOffset: -5,  hour: 14,  duration: 45,  status: "completed", notes: "Pregătire competiție mai" }),
  appt({ clientId: 18, clientName: "Victor Dinu",         clientPhone: "+40745100018", staffId: 3, serviceId: 4, serviceName: "Manipulare miofascială", servicePrice: 200, daysOffset: -4,  hour: 10,  duration: 45,  status: "completed" }),
  appt({ clientId: 6,  clientName: "Cristina Stoica",     clientPhone: "+40745100006", staffId: 4, serviceId: 7, serviceName: "Kinetoterapie",          servicePrice: 150, daysOffset: -3,  hour: 15,  duration: 45,  status: "no_show" }),
  appt({ clientId: 20, clientName: "Alexandru Anghel",    clientPhone: "+40745100020", staffId: 1, serviceId: 1, serviceName: "Consultație inițială",   servicePrice: 200, daysOffset: -2,  hour: 11,  duration: 60,  status: "completed" }),
  appt({ clientId: 9,  clientName: "Vlad Radu",           clientPhone: "+40745100009", staffId: 2, serviceId: 5, serviceName: "Tratament cervicalgie",  servicePrice: 180, daysOffset: -2,  hour: 14,  duration: 45,  status: "completed" }),
  appt({ clientId: 13, clientName: "Sebastian Bucur",     clientPhone: "+40745100013", staffId: 3, serviceId: 6, serviceName: "Tratament lombalgie",    servicePrice: 220, daysOffset: -1,  hour: 10,  duration: 60,  status: "completed" }),
  appt({ clientId: 4,  clientName: "Ioana Dumitrescu",    clientPhone: "+40745100004", staffId: 4, serviceId: 8, serviceName: "Evaluare posturală",     servicePrice: 180, daysOffset: -1,  hour: 14,  duration: 45,  status: "completed" }),

  appt({ clientId: 1,  clientName: "Andrei Stoica",       clientPhone: "+40745100001", staffId: 1, serviceId: 2, serviceName: "Consultație de control", servicePrice: 100, daysOffset: 0,   hour: 9,   duration: 30,  status: "approved" }),
  appt({ clientId: 15, clientName: "George Neagu",        clientPhone: "+40745100015", staffId: 3, serviceId: 4, serviceName: "Manipulare miofascială", servicePrice: 200, daysOffset: 0,   hour: 10,  duration: 45,  status: "approved" }),
  appt({ clientId: 12, clientName: "Roxana Stan",         clientPhone: "+40745100012", staffId: 2, serviceId: 7, serviceName: "Kinetoterapie",          servicePrice: 150, daysOffset: 0,   hour: 11,  duration: 45,  status: "booked" }),
  appt({ clientId: 19, clientName: "Nicoleta Grigore",    clientPhone: "+40745100019", staffId: 4, serviceId: 4, serviceName: "Manipulare miofascială", servicePrice: 200, daysOffset: 0,   hour: 13,  duration: 45,  status: "booked" }),
  appt({ clientId: 5,  clientName: "Bogdan Gheorghe",     clientPhone: "+40745100005", staffId: 1, serviceId: 6, serviceName: "Tratament lombalgie",    servicePrice: 220, daysOffset: 0,   hour: 14,  duration: 60,  status: "booked" }),
  appt({ clientId: 17, clientName: "Luminița Vlad",       clientPhone: "+40745100017", staffId: 4, serviceId: 7, serviceName: "Kinetoterapie",          servicePrice: 150, daysOffset: 0,   hour: 16,  duration: 45,  status: "booked" }),

  appt({ clientId: 2,  clientName: "Elena Popescu",       clientPhone: "+40745100002", staffId: 3, serviceId: 5, serviceName: "Tratament cervicalgie",  servicePrice: 180, daysOffset: 1,   hour: 10,  duration: 45,  status: "booked" }),
  appt({ clientId: 7,  clientName: "Mihai Marin",         clientPhone: "+40745100007", staffId: 1, serviceId: 4, serviceName: "Manipulare miofascială", servicePrice: 200, daysOffset: 1,   hour: 14,  duration: 45,  status: "booked" }),
  appt({ clientId: 11, clientName: "Tudor Nistor",        clientPhone: "+40745100011", staffId: 1, serviceId: 6, serviceName: "Tratament lombalgie",    servicePrice: 220, daysOffset: 2,   hour: 9,   duration: 60,  status: "approved", notes: "Ședință 3 din protocol" }),
  appt({ clientId: 8,  clientName: "Alina Popa",          clientPhone: "+40745100008", staffId: 2, serviceId: 7, serviceName: "Kinetoterapie",          servicePrice: 150, daysOffset: 3,   hour: 11,  duration: 45,  status: "booked" }),
  appt({ clientId: 3,  clientName: "Cristian Marinescu",  clientPhone: "+40745100003", staffId: 4, serviceId: 4, serviceName: "Manipulare miofascială", servicePrice: 200, daysOffset: 4,   hour: 10,  duration: 45,  status: "booked" }),
  appt({ clientId: 10, clientName: "Mihaela Lungu",       clientPhone: "+40745100010", staffId: 1, serviceId: 3, serviceName: "Osteopatie viscerală",   servicePrice: 250, daysOffset: 5,   hour: 9,   duration: 60,  status: "booked" }),
  appt({ clientId: 20, clientName: "Alexandru Anghel",    clientPhone: "+40745100020", staffId: 2, serviceId: 7, serviceName: "Kinetoterapie",          servicePrice: 150, daysOffset: 6,   hour: 14,  duration: 45,  status: "booked" }),
  appt({ clientId: 14, clientName: "Simona Tudor",        clientPhone: "+40745100014", staffId: 3, serviceId: 1, serviceName: "Consultație inițială",   servicePrice: 200, daysOffset: 7,   hour: 10,  duration: 60,  status: "booked" }),
];

export const PRODUCTS = [
  { id: 1, name: "Mănuși latex M (cutie 100)",        sku: "MED-001", category: "Consumabile",  unit: "cutie",  price: "55.00",  business: 1, is_active: true },
  { id: 2, name: "Mască chirurgicală 3 straturi",     sku: "MED-002", category: "Consumabile",  unit: "cutie",  price: "30.00",  business: 1, is_active: true },
  { id: 3, name: "Hârtie pat consultație 60cm",       sku: "MED-003", category: "Consumabile",  unit: "rolă",   price: "22.00",  business: 1, is_active: true },
  { id: 4, name: "Cremă masaj profesională Klafs",    sku: "TER-001", category: "Tratamente",   unit: "borcan", price: "85.00",  business: 1, is_active: true },
  { id: 5, name: "Kinesio tape 5cm × 5m",             sku: "TER-002", category: "Tratamente",   unit: "rolă",   price: "45.00",  business: 1, is_active: true },
  { id: 6, name: "Soluție dezinfectant suprafețe 5L", sku: "DEZ-001", category: "Igienă",       unit: "canistră", price: "75.00", business: 1, is_active: true },
];

export const STOCK_LEVELS = [
  { product: 1, product_name: "Mănuși latex M (cutie 100)",        location: 1, quantity: 18, min_quantity: 5 },
  { product: 2, product_name: "Mască chirurgicală 3 straturi",     location: 1, quantity: 12, min_quantity: 3 },
  { product: 3, product_name: "Hârtie pat consultație 60cm",       location: 1, quantity: 22, min_quantity: 8 },
  { product: 4, product_name: "Cremă masaj profesională Klafs",    location: 1, quantity: 4,  min_quantity: 2 },
  { product: 5, product_name: "Kinesio tape 5cm × 5m",             location: 1, quantity: 3,  min_quantity: 3 },
  { product: 6, product_name: "Soluție dezinfectant suprafețe 5L", location: 1, quantity: 2,  min_quantity: 1 },
];

export const STOCK_MOVEMENTS = [
  { id: 1, product: 1, product_name: "Mănuși latex M (cutie 100)",     type: "receive", quantity: 10, notes: "Comandă lunară",  created_at: "2026-03-15T10:00:00Z" },
  { id: 2, product: 3, product_name: "Hârtie pat consultație 60cm",    type: "receive", quantity: 12, notes: "Reaprovizionare", created_at: "2026-03-18T11:00:00Z" },
  { id: 3, product: 4, product_name: "Cremă masaj profesională Klafs", type: "adjust",  quantity: -1, notes: "Defect ambalaj",  created_at: "2026-03-20T09:30:00Z" },
];
